// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"882a04c4","501":"36f91240"}[chunkId] + ".chunk.js";
};